import styled from "@emotion/styled";
import FlexCenter from "shared/components/Layout/components/FlexCenter";

export const StyledRefreshButton = styled(FlexCenter)`
  transform: scaleX(-1) rotate(-35deg);
`;
